module.exports = __webpack_public_path__ + "static/media/ok-drop.cd649860.svg";